import { ForumUser } from "@/app/models/forum/new-forum.model"
import {Actions} from "@redux/actions/new-resource";

export const NewForumActions = {
    SET_STORE_LIST: 'SET_STORE_LIST',
    SET_USER_LIST: 'SET_USER_LIST',
    SET_SMART_FILTER: 'SET_SMART_FILTER',
}

export const setNewForumStoreList = (storeList: {store_id: string}[]) => {
    return { type: NewForumActions.SET_STORE_LIST, storeList }
}

export const setUserList = (userList: ForumUser[]) => {
    return { type: NewForumActions.SET_USER_LIST, userList }
}

export const setSmartFilterForum = (value: any) => {
    return { type: Actions.SET_SMART_FILTER, value }
}